"use strict";
import ViewBase from "../view-base.view";
import surveyModel from "../../models/survey/survey.model";
import FileUploadComponent from "../../components/file/file-upload.component";

export default function UploadQuestionsView() {
  ViewBase.call(this);

  const FORM_DATA_FILE_KEY = "file";

  let surveyId = "";
  let fileFormData = new FormData();
  let closeModal = () => { }
  let onUploadCompleted = () => { }

  let _uploadExcelTemplate = (e) => {
    if (fileFormData && fileFormData.get(FORM_DATA_FILE_KEY)) {
      this.showLoading();

      surveyModel.uploadQuestions(
        () => {
          this.hideLoading();
          onUploadCompleted();
        },
        () => {
          this.hideLoading();
          this.showErrorMessage(this.getText("EM00000138", "Server error. Please contact administrator."),
            this.getText("EM00000142", "Error"),
            null);
        },
        surveyId,
        fileFormData
      );
    } else {
      this.showErrorMessage(this.getText("EM00000138", "Server error. Please contact administrator."),
        this.getText("EM00000142", "Error"),
        null);
    }
  }

  return {
    oninit: (vnode) => {
      if (typeof vnode.attrs.closeModal === 'function') {
        closeModal = vnode.attrs.closeModal;
      }
      if (vnode.attrs.onUploadCompleted) {
        onUploadCompleted = vnode.attrs.onUploadCompleted;
      }
      if (vnode.attrs.surveyId) {
        surveyId = vnode.attrs.surveyId;
      }
    },
    view: () => {
      return [
        m('.container',
          m('.row.g-3',
            m('.col-12',
              m('label.form-label', this.getText("LT00000515", "Upload Excel")),
              m(FileUploadComponent, {
                acceptableFileTypes: ['.xlsx'],
                isOnlySingleFileUpload: true,
                onGettingFiles: (files) => {
                  if (files.length > 0) {
                    fileFormData.append(FORM_DATA_FILE_KEY, files[0]);
                  } else {
                    fileFormData = new FormData();
                  }
                }
              })
            ),
            m('.d-flex.gap-2.justify-content-end.mt-4',
              m('button.btn.btn-primary[type=button]', { onclick: () => _uploadExcelTemplate() },
                this.getText("LT00000290", "Upload")
              ),
              m('button.btn.btn-white[type=button]', {
                onclick: () => { closeModal() }
              },
                this.getText("LT00000021")
              ),
            )
          )
        ),
        this.getBaseViews()
      ]
    }
  }
}